    import React, { useEffect, useState } from 'react';
    import { useLocation, useNavigate } from 'react-router-dom';
    import './CarsInfoPageBlock.css';
    import config from '../config/config';
    import CarFormPage from '../manualInputCarInfo/CarFormPage';

    const restartVerifyCode = `${config.apiUrl1}/api/verification-codes/verify-code-restart`;

    const CarsInfoPageBlock = () => {
        const location = useLocation();
        const navigate = useNavigate();
        const [carFormModalData, setCarFormModalData] = useState({ marka: null, model: null, year: null, texPasport:null,carNumber:null });

        const [showSuccessModal, setShowSuccessModal] = useState(false);

        const { techPassportSeria, techPassportNumber, govNumber } = location.state || {};

        const [resendLoading, setResendLoading] = useState(false);
        const [resendMessage, setResendMessage] = useState('');

        const [vehicleInfo, setVehicleInfo] = useState(null);
        const [showOwnerMismatchModal, setShowOwnerMismatchModal] = useState(false);
        const [carPrice, setCarPrice] = useState(null);
        const [step, setStep] = useState(0);
        const [selectedInsurance, setSelectedInsurance] = useState(null);
        const [selectedInsuranceId, setSelectedInsuranceId] = useState(null);
        const [selectedTariff, setSelectedTariff] = useState(null);
        const [showModal, setShowModal] = useState(false);
        const [confirmationCode, setConfirmationCode] = useState('');
        const [passportInfo, setPassportInfo] = useState(null);
        const [insuranceCompanies, setInsuranceCompanies] = useState([]);
        const [error, setError] = useState('');
        const [showCarFormModal, setShowCarFormModal] = useState(false);

        const [formData, setFormData] = useState({
            carNumber: '',
            techPassport: '',
            passportSeries: '',
            passportNumber: '',
            birthDate: '',
            applicantPhone: '',
        });

    // ==== внутри CarsInfoPageBlock ====
         const [attempts, setAttempts] = useState(0); // ✅ счётчик попыток

         const MAX_ATTEMPTS = 2; // ✅ лимит попыток

    // следим за количеством попыток
        useEffect(() => {
            if (attempts === 1 && MAX_ATTEMPTS === 2) {
                alert("❌ Код неверный. Осталась 1 попытка");
            } else if (attempts >= MAX_ATTEMPTS) {
                alert("❌ Код неверный. Попытки закончились.");
                setShowModal(false);
                navigate("/");
            }
        }, [attempts, navigate]);

    // ====== Проверка кода
        const handleConfirmCode = async () => {
            try {
                const response = await fetch(`${config.apiUrl1}/api/verification-codes/verify-code`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'User-Agent': 'insomnia/11.2.0' },
                    body: JSON.stringify({
                        phone: formData.applicantPhone,
                        verifyCode: Number(confirmationCode),
                    }),
                });

                const verified = await response.json();

                if (!response.ok) {
                    alert('Ошибка сервера при верификации');
                    return;
                }

                if (verified === true) {
                    // ✅ Успешно
                    localStorage.setItem('phoneNumber', formData.applicantPhone);
                    localStorage.setItem('userId_createdAt', new Date().toISOString());

                    setShowModal(false);
                    setStep(3); // финальный шаг

                    const basePrice = carPrice?.amount ?? carPrice?.price ?? carPrice?.value;
                    const insurancePremium = calcPremium(selectedTariff?.amount, basePrice);

                    const payload = {
                        brand: vehicleInfo?.data?.markaName,
                        brandId: carPrice?.brandId,
                        model: vehicleInfo?.data?.modelName,
                        modelId: carPrice?.modelId,
                        year: vehicleInfo?.data?.issueYear,
                        yearId: carPrice?.yearId,
                        price: carPrice?.price,
                        insuranceCompany: selectedInsurance,
                        insuranceCompanyId: selectedInsuranceId,
                        tariff: selectedTariff?.name,
                        tariffId: selectedTariff?.id,
                        amount: selectedTariff?.amount,
                        ownerAuto: vehicleInfo?.data?.owner,
                        insurancePremium,
                        carNumber: vehicleInfo?.data?.govNumber,
                        techPassport: `${techPassportSeria}${techPassportNumber}`,
                        passportSeries: formData.passportSeries,
                        passportNumber: formData.passportNumber,
                        birthDate: formData.birthDate,
                        applicantPhone: formData.applicantPhone,
                        passportInfo,
                    };

                    try {
                        const orderResponse = await fetch(`${config.apiUrl2}/api/orders/create-order`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(payload),
                        });
                        if (!orderResponse.ok) throw new Error('Ошибка при создании заказа');
                        setShowSuccessModal(true);
                    } catch (err) {
                        console.error('❌ Ошибка при создании заказа:', err);
                    }
                } else {
                    // ❌ Код неверный
                    setAttempts(prev => prev + 1);
                }
            } catch (error) {
                alert('Сетевая ошибка');
                console.error('Ошибка при верификации:', error);
            }
        };


        const handleResend = async () => {
            if (!formData.applicantPhone) {
                alert('Введите номер телефона заявителя!');
                return;
            }

            setResendLoading(true);
            setResendMessage('⏳ Отправляем новый код...');

            try {
                const response = await fetch(restartVerifyCode, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'User-Agent': 'insomnia/11.3.0',
                    },
                    body: JSON.stringify({ phone: formData.applicantPhone }),
                });

                if (!response.ok) {
                    setResendMessage('❌ Ошибка при отправке нового кода');
                } else {
                    setResendMessage('📲 Новый код отправлен на телефон');
                    setConfirmationCode('');
                }
            } catch {
                setResendMessage('❌ Сетевая ошибка при отправке кода');
            } finally {
                setResendLoading(false);
            }
        };


        // ===== Helpers
        const safeNumber = (val) => {
            const n = Number(val);
            return Number.isFinite(n) ? n : 0;
        };

        const calcPremium = (percentStr, basePrice) => {
            if (!percentStr || !basePrice) return null;
            const percent = parseFloat(String(percentStr).replace('%', '').trim());
            const price = safeNumber(basePrice);
            if (!Number.isFinite(percent) || !Number.isFinite(price)) return null;
            return Math.round((percent / 100) * price);
        };

        // ====== Загрузка авто по паспорту
        const loadCarData = async () => {
            try {
                const response = await fetch(`${config.apiUrl1}/api/passport/get-vehicle-data`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ techPassportSeria, techPassportNumber, govNumber }),
                });

                if (!response.ok) throw new Error(`Ошибка запроса: ${response.status}`);

                const data = await response.json();
                setVehicleInfo(data);

                // ✅ заполняем форму гос. номером и техпаспортом
                setFormData((prev) => ({
                    ...prev,
                    carNumber: data?.data?.govNumber || govNumber || '',
                    techPassport: `${techPassportSeria || ''}${techPassportNumber || ''}`,
                }));
            } catch (err) {
                console.error('Ошибка при получении данных:', err);
                setError('Не удалось загрузить данные');
                setCarFormModalData({
                    marka: null,
                    model: null,
                    year: null,
                    texPassport: null,
                    gosNumber: null,
                });
                setShowCarFormModal(true);
            }
        };



    //sdcsdcsd
        useEffect(() => {
            if (!techPassportSeria || !techPassportNumber || !govNumber) {
                setError('Отсутствуют параметры паспорта');
                return;
            }
            loadCarData();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [techPassportSeria, techPassportNumber, govNumber]);

        // ====== Цена авто (по марке/модели/году)
        useEffect(() => {
            const fetchCarPrice = async () => {
                const marka = vehicleInfo?.data?.markaName || null;
                const model = vehicleInfo?.data?.modelName || null;
                const year = vehicleInfo?.data?.issueYear || null;

                // ✅ если нет marka, model или year → сразу модалка с null
                if (!marka || !model || !year) {
                    setCarFormModalData({
                        marka: null,
                        model: null,
                        year: null,
                        texPassport: null,
                        gosNumber: null,
                    });
                    setShowCarFormModal(true);
                    return;
                }

                try {
                    const brandName = encodeURIComponent(marka);
                    const modelName = encodeURIComponent(model);
                    const vehicleYear = encodeURIComponent(year);

                    const response = await fetch(
                        `${config.apiUrl2}/api/cars/get-price?brandName=${brandName}&modelName=${modelName}&year=${vehicleYear}`,
                        { method: 'GET', headers: { 'User-Agent': 'insomnia/11.3.0' } }
                    );

                    if (!response.ok) throw new Error('Ошибка при получении цены');

                    const data = await response.json();
                    const price = Number(data?.price);

                    // 🚫 если цена некорректная → открываем модалку с реальными данными
                    if (!data || !data.price || price <= 0 || isNaN(price)) {
                        setCarFormModalData({
                            marka,
                            model,
                            year,
                            texPassport: `${techPassportSeria || ''}${techPassportNumber || ''}` || null,
                            carNumber: govNumber || null,
                        });
                        setShowCarFormModal(true);
                        return;
                    }

                    setCarPrice(data);
                } catch (e) {
                    console.error('❌ Ошибка при получении стоимости авто:', e);
                    setCarFormModalData({
                        marka: null,
                        model: null,
                        year: null,
                        texPassport: null,
                        carNumber: null,
                    }); // ❌ ошибка → null
                    setShowCarFormModal(true);
                }
            };

            if (vehicleInfo) fetchCarPrice();
        }, [vehicleInfo, techPassportSeria, techPassportNumber, govNumber]);


        // ====== Компании/тарифы
        useEffect(() => {
            const fetchInsuranceData = async () => {
                try {
                    const response = await fetch(`${config.apiUrl2}/api/insurance/insurance-and-tariff`, {
                        method: 'GET',
                        headers: { 'User-Agent': 'insomnia/11.2.0' },
                    });

                    if (!response.ok) throw new Error('Ошибка при получении страховых компаний');

                    const data = await response.json();

                    const grouped = data.reduce((acc, item) => {
                        const name = item.insuranceName;
                        const companyId = item.tariff.companyId;

                        if (!acc[name]) {
                            acc[name] = { name, id: companyId, tariffs: {} };
                        }

                        acc[name].tariffs[item.tariff.name] = {
                            id: item.tariff.id,
                            price: `${item.tariff.percent}%`,
                            description: item.tariff.description || 'Описание отсутствует',
                        };

                        return acc;
                    }, {});

                    setInsuranceCompanies(Object.values(grouped));
                } catch (err) {
                    console.error('❌ Ошибка загрузки страховых компаний:', err);
                }
            };

            fetchInsuranceData();
        }, []);

        // ====== Выбор тарифа
        const handleTariffSelection = (company, tariffName) => {
            const marka = vehicleInfo?.data?.markaName || null;
            const model = vehicleInfo?.data?.modelName || null;
            const year = vehicleInfo?.data?.issueYear || null;

            const basePrice = carPrice?.amount ?? carPrice?.price ?? carPrice?.value;
            const price = Number(basePrice);

            // 🚫 Проверка: если нет суммы авто или она некорректная → открываем ручной ввод
            if (!carPrice || !price || isNaN(price) || price <= 0) {
                alert("❗ Сумма автомобиля отсутствует или некорректна. Введите её вручную.");
                setCarFormModalData({ marka, model, year,  texPassport: `${techPassportSeria || ''}${techPassportNumber || ''}` || null, carNumber: govNumber || null, }); // ✅ если данные есть — передаём их
                setShowCarFormModal(true);
                return;
            }

            const tariff = company.tariffs[tariffName];
            setSelectedInsurance(company.name);
            setSelectedInsuranceId(company.id);
            setSelectedTariff({ name: tariffName, amount: tariff.price, id: tariff.id });
            setStep(1);
        };



        // ====== Паспортные данные
        const fetchPassportInfo = async () => {
            try {
                const response = await fetch(`${config.apiUrl1}/api/passport/get-passport-data`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'User-Agent': 'insomnia/11.2.0' },
                    body: JSON.stringify({
                        birthDate: formData.birthDate,
                        passportSeries: formData.passportSeries,
                        passportNumber: formData.passportNumber,
                    }),
                });

                const result = await response.json();

                if (result.result === 0) {
                    setPassportInfo(result);

                    // Проверка владельца
                    const ownerPinfl = vehicleInfo?.data?.pinfl;
                    if (ownerPinfl && result.pinfl && ownerPinfl !== result.pinfl) {
                        setShowOwnerMismatchModal(true);
                    } else {
                        setStep((p) => p + 1);
                    }
                } else {
                    alert('❌ Данные не найдены или некорректны.');
                }
            } catch (error) {
                console.error('Ошибка API:', error);
                alert('Ошибка при запросе к серверу.');
            }
        };

        // ====== Дата в инпуте
        const handleDateInput = (e) => {
            let value = e.target.value.replace(/\D/g, '').slice(0, 8);
            if (value.length >= 5) value = `${value.slice(0, 2)}.${value.slice(2, 4)}.${value.slice(4)}`;
            else if (value.length >= 3) value = `${value.slice(0, 2)}.${value.slice(2)}`;
            setFormData({ ...formData, birthDate: value });
        };

        // ====== Создание пользователя
        const createUser = async () => {
            if (!passportInfo || !formData.applicantPhone) {
                console.warn('Нет данных для создания пользователя.');
                return;
            }

            const fullName = `${passportInfo.first_name_eng} ${passportInfo.last_name_eng} ${passportInfo.middle_name || ''}`.trim();

            const payload = {
                full_name: fullName,
                phone_number: formData.applicantPhone,
                passport_number: `${formData.passportSeries}${formData.passportNumber}`,
            };

            try {
                const response = await fetch(`${config.apiUrl1}/api/users/create`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'User-Agent': 'insomnia/11.1.0' },
                    body: JSON.stringify(payload),
                });

                if (!response.ok) throw new Error('❌ Ошибка при создании пользователя');

                const userId = await response.json();
                localStorage.setItem('userId_createdAt', new Date().toISOString());
                console.log('✅ Пользователь создан. ID:', userId);
            } catch (error) {
                console.error('Ошибка создания пользователя:', error);
            }
        };

        // ====== UI части
        const renderStepsBar = () => {
            const steps = ['Инфо и страховка', 'Владелец авто', 'Заявитель', 'Готово'];
            return (
                <div className="steps" aria-label="Ход оформления">
                    {steps.map((label, index) => (
                        <div key={label} className={`step ${index === step ? 'active' : ''}`}>
                            <span className="step-circle">{index + 1}</span>
                            <p className="step-label">{label}</p>
                        </div>
                    ))}
                </div>
            );
        };

        const renderInsuranceList = () => {
            const basePrice = carPrice?.amount ?? carPrice?.price ?? carPrice?.value;
            return (
                <div className="insurance-list">
                    <h3>📋 Доступные страховые фирмы</h3>
                    {insuranceCompanies.map((company, idx) => (
                        <div key={idx} className="insurance-item">
                            <div className="insurance-head">
                                <strong className="company-name">{company.name}</strong>
                            </div>

                            {Object.entries(company.tariffs).map(([tariffName, tariffData]) => {
                                const premium = calcPremium(tariffData.price, basePrice);
                                return (
                                    <div key={tariffName} className="tariff-option">
                                        <div className="tariff-main">
                        <span className="tariff-title">
                          {tariffName.toUpperCase()} — 💸 страховая премия:{' '}
                            {premium ? `${premium.toLocaleString('ru-RU')} сум` : 'не указана'}
                        </span>
                                            <button
                                                className="btn btn-primary btn-sm"
                                                onClick={() => handleTariffSelection(company, tariffName)}
                                            >
                                                Выбрать
                                            </button>
                                        </div>

                                        <div className="tariff-description-row">
                                            <span className="tariff-icon">📖</span>
                                            <span className="tariff-text">{tariffData.description || 'Описание отсутствует'}</span>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            );
        };

        const renderSummary = () => {
            const basePrice = carPrice?.amount ?? carPrice?.price ?? carPrice?.value;
            const premium = calcPremium(selectedTariff?.amount, basePrice);

            return (
                <div className="summary-container">
                    <div className="summary-column">
                        {selectedInsurance && (
                            <>
                                <h2>📄 Информация</h2>
                                <p><strong>Страховая компания:</strong> {selectedInsurance}</p>
                                <p><strong>Тариф:</strong> {selectedTariff?.name?.toUpperCase()}</p>
                                <p>
                                    <strong>Страховая премия:</strong>{' '}
                                    {premium ? `${premium.toLocaleString('ru-RU')} сум` : 'не указана'}
                                </p>
                            </>
                        )}

                        {formData.applicantPhone && (
                            <p><strong>Телефон заявителя:</strong> {formData.applicantPhone}</p>
                        )}
                        {formData.passportSeries && formData.passportNumber && (
                            <p><strong>Паспорт:</strong> {formData.passportSeries}{formData.passportNumber}</p>
                        )}
                        {formData.birthDate && <p><strong>Дата рождения:</strong> {formData.birthDate}</p>}
                    </div>

                    <div className="vehicle-info-box">
                        <h3>📄 Информация об автомобиле</h3>
                        {error && <p className="text-error">{error}</p>}

                        {vehicleInfo ? (
                            <div className="vehicle-info">
                                <p><strong>Марка:</strong> {vehicleInfo.data?.markaName}</p>
                                <p><strong>Модель:</strong> {vehicleInfo.data?.modelName}</p>
                                <p><strong>Год выпуска:</strong> {vehicleInfo.data?.issueYear}</p>
                                <p><strong>Цвет:</strong> {vehicleInfo.data?.vehicleColor}</p>
                                <p><strong>Гос. номер:</strong> {vehicleInfo.data?.govNumber}</p>
                                <p><strong>Дата выдачи техпаспорта:</strong> {vehicleInfo.data?.techPassportIssueDate}</p>
                                <p>
                                    <strong>Сумма автомобиля:</strong>{' '}
                                    {carPrice?.price ? `${Number(carPrice.price).toLocaleString('ru-RU')} сум` : 'не указана'}
                                </p>
                            </div>
                        ) : error ? (
                            <p className="text-error">❌ Ошибка: {error}</p>
                        ) : (
                            <p>Загрузка данных о ТС...</p>
                        )}
                    </div>
                </div>
            );
        };

        const renderStepContent = () => {
            switch (step) {
                case 0:
                    return (
                        <>
                            <h2>🚗 Информация о авто</h2>

                            {vehicleInfo ? (
                                <div className="card vehicle-card">
                                    <h3>📄 Информация о ТС</h3>
                                    <div className="vehicle-grid">
                                        <p><strong>Марка:</strong> {vehicleInfo.data?.markaName}</p>
                                        <p><strong>Модель:</strong> {vehicleInfo.data?.modelName}</p>
                                        <p><strong>Год выпуска:</strong> {vehicleInfo.data?.issueYear}</p>
                                        <p><strong>Цвет:</strong> {vehicleInfo.data?.vehicleColor}</p>
                                        <p><strong>Номер кузова:</strong> {vehicleInfo.data?.bodyNumber}</p>
                                        <p><strong>Номер двигателя:</strong> {vehicleInfo.data?.engineNumber}</p>
                                        <p><strong>Гос. номер:</strong> {vehicleInfo.data?.govNumber}</p>
                                        <p><strong>Масса пустого ТС:</strong> {vehicleInfo.data?.emptyWeight} кг</p>
                                        <p><strong>Масса полная:</strong> {vehicleInfo.data?.fullWeight} кг</p>
                                        <p><strong>Количество мест:</strong> {vehicleInfo.data?.seats}</p>
                                    </div>

                                    <h4>👤 Владелец:</h4>
                                    <div className="owner-grid">
                                        <p><strong>ФИО:</strong> {vehicleInfo.data?.owner}</p>
                                        <p><strong>PINFL:</strong> {vehicleInfo.data?.pinfl}</p>
                                        <p><strong>Дата выдачи техпаспорта:</strong> {vehicleInfo.data?.techPassportIssueDate}</p>
                                        <p><strong>Подразделение:</strong> {vehicleInfo.data?.division}</p>
                                    </div>

                                    <p className="car-amount">
                                        <strong>Сумма автомобиля:</strong>{' '}
                                        {carPrice?.price ? `${Number(carPrice.price).toLocaleString('ru-RU')} сум` : 'не указана'}
                                    </p>
                                </div>
                            ) : error ? (
                                <p className="text-error">❌ Ошибка: {error}</p>
                            ) : (
                                <p>Загрузка данных о ТС...</p>
                            )}

                            {renderInsuranceList()}
                        </>
                    );

                case 1:
                    return (
                        <>
                            {renderSummary()}
                            <h2>👤 Паспортные данные владельца</h2>

                            <div className="input-row">
                                <input
                                    type="text"
                                    maxLength={2}
                                    placeholder="Серия паспорта (например, AB)"
                                    value={formData.passportSeries}
                                    onChange={(e) => {
                                        const onlyLetters = e.target.value.toUpperCase().replace(/[^A-Z]/g, '');
                                        setFormData({ ...formData, passportSeries: onlyLetters });
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder="Номер паспорта (например, 1234567)"
                                    value={formData.passportNumber}
                                    onChange={(e) => {
                                        const digits = e.target.value.replace(/\D/g, '').slice(0, 9);
                                        setFormData({ ...formData, passportNumber: digits });
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder="Дата рождения (ДД.ММ.ГГГГ)"
                                    value={formData.birthDate}
                                    onChange={handleDateInput}
                                    maxLength={10}
                                    inputMode="numeric"
                                />
                            </div>

                            <button className="btn btn-primary" onClick={fetchPassportInfo}>Дальше</button>
                        </>
                    );

                case 2:
                    return (
                        <>
                            {renderSummary()}
                            <h2>📄 Информация по паспорту</h2>

                            {passportInfo ? (
                                <div className="passport-info-box">
                                    <p><strong>Фамилия (ENG):</strong> {passportInfo.last_name_eng}</p>
                                    <p><strong>Имя (ENG):</strong> {passportInfo.first_name_eng}</p>
                                    <p><strong>Отчество:</strong> {passportInfo.middle_name}</p>
                                    <p><strong>PINFL:</strong> {passportInfo.pinfl}</p>
                                    <p><strong>Дата рождения:</strong> {passportInfo.birth_date}</p>
                                    <p><strong>Адрес:</strong> {passportInfo.address}</p>
                                    <p><strong>Пол:</strong> {passportInfo.gender === '1' ? 'Мужской' : 'Женский'}</p>
                                </div>
                            ) : (
                                <p>❗ Паспортные данные не найдены.</p>
                            )}

                            <h2>📞 Заявитель</h2>
                            <div className="phone-block">
                                <input
                                    type="text"
                                    className="input-phone"
                                    placeholder="+998 __ ___ __ __"
                                    value={formData.applicantPhone || '+998'}
                                    onFocus={(e) => {
                                        setTimeout(() => {
                                            if (e.target.setSelectionRange) {
                                                e.target.setSelectionRange(e.target.value.length, e.target.value.length);
                                            }
                                        }, 0);
                                    }}
                                    onChange={(e) => {
                                        let value = e.target.value.replace(/\D/g, '');
                                        if (!value.startsWith('998')) value = '998' + value;
                                        value = value.slice(0, 12);
                                        setFormData({ ...formData, applicantPhone: '+' + value });
                                    }}
                                />

                                <button
                                    className="btn btn-primary"
                                    onClick={async () => {
                                        if (!formData.applicantPhone) {
                                            alert('Введите номер телефона заявителя!');
                                            return;
                                        }
                                        await createUser();
                                        setShowModal(true);
                                    }}
                                >
                                    Готово
                                </button>
                            </div>
                        </>
                    );

                case 3:
                    return (
                        <div className="thank-you">
                            {renderSummary()}
                            <h2>✅ Спасибо!</h2>
                            <p>Все данные успешно заполнены.</p>
                            <button className="btn btn-secondary" onClick={() => navigate('/')}>На главную</button>
                        </div>
                    );

                default:
                    return null;
            }
        };

        return (
            <div className="eosago-page">
                <main>
                    {renderStepsBar()}

                    <section className="data-block">
                        {renderStepContent()}
                        {step > 0 && step < 3 && (
                            <p className="agreement">
                                Нажимая «Продолжить», вы соглашаетесь с офертой и даёте согласие на обработку персональных данных.
                            </p>
                        )}
                        {step > 0 && (
                            <button className="back-btn" onClick={() => (step === 0 ? navigate('/') : setStep((p) => p - 1))}>
                                ← Назад
                            </button>
                        )}
                    </section>
                </main>

                {/* Несовпадение владельца */}
                {showOwnerMismatchModal && (
                    <div className="modal-overlay" role="dialog" aria-modal="true">
                        <div className="modal">
                            <h3>⚠️ Внимание</h3>
                            <p>Владелец автомобиля не совпадает с введённым паспортом.</p>
                            <div className="modal-buttons">
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        setShowOwnerMismatchModal(false);
                                        // navigate ('/');
                                    }}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                )}


                 {/* Модалка — SMS код */}
                {showModal && (
                    <div className="modal-overlay" role="dialog" aria-modal="true">
                        <div className="modal">
                            <h3>Введите код подтверждения</h3>
                            <p>Мы отправили SMS на номер {formData.applicantPhone}</p>
                            <input
                                type="text"
                                inputMode="numeric"
                                placeholder="Введите код (например, 123)"
                                value={confirmationCode}
                                onChange={(e) => setConfirmationCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                            />
                            <div className="modal-buttons">
                                <button className="btn btn-primary" onClick={handleConfirmCode}>
                                    Подтвердить
                                </button>

                                {/* Кнопка "Переотправить" появится только после 1-й ошибки */}
                                {attempts > 0 && (
                                    <button
                                        className="btn btn-resend"
                                        onClick={handleResend}
                                        disabled={resendLoading}
                                    >
                                        {resendLoading ? '⏳ Отправляем...' : '🔄 Переотправить код'}
                                    </button>
                                )}

                                {resendMessage && <p className="status">{resendMessage}</p>}
                                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                    Отмена
                                </button>
                            </div>
                        </div>
                    </div>
                )}


                {/* === Модальное окно для ручного ввода авто === */}
                {showCarFormModal && (
                    <div className="modal-overlay" role="dialog" aria-modal="true">
                        <div className="modal">
                            <CarFormPage
                                marka={carFormModalData?.marka || ""}
                                model={carFormModalData?.model || ""}
                                year={carFormModalData?.year || ""}
                                texPassport={carFormModalData?.texPassport || ""}
                                carNumber={carFormModalData?.carNumber || ""}
                                onClose={() => setShowCarFormModal(false)}
                            />
                        </div>
                    </div>
                )}


                {showSuccessModal && (
                    <div className="modal-overlay">
                        <div className="modal">
                            <h3>✅ Заказ успешно создан</h3>
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    setShowSuccessModal(false);
                                    navigate('/profile-page');
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                )}

            </div>
        );
    };

    export default CarsInfoPageBlock;
